import React, { useState } from 'react';
import { observer } from 'mobx-react';
import _ from 'lodash';
import { Button, Popover, FormControlLabel, Checkbox, FormGroup, Box, FormLabel } from '@material-ui/core';
import type { OrderItemStepStatusKey } from '@this/src/domain/order_item/order_item_step_status';
import {
  OrderItemStepStatus,
  OrderItemStepStatusAvailable
} from '@this/src/domain/order_item/order_item_step_status';

interface Props {
  selectedOrderItemStepStatuses: OrderItemStepStatusKey[];
  onChangeSelectedOrderItemStepStatuses: (statuses: OrderItemStepStatusKey[]) => void;
}

const OrderItemStepStatusSelector = observer(
  ({ selectedOrderItemStepStatuses, onChangeSelectedOrderItemStepStatuses }: Props) => {
    const [anchorEl, setAnchorEl] = useState<Element | null>(null);

    const handleClickOrderItemFilterButton = (e: React.MouseEvent) => {
      setAnchorEl(e.currentTarget);
    };

    const handleCloseOrderItemFilter = () => {
      setAnchorEl(null);
    };

    const handleSelectAllOrderItemStepStatuses = (e: React.ChangeEvent<HTMLInputElement>) => {
      const statuses = e.target.checked ? OrderItemStepStatusAvailable : [];
      onChangeSelectedOrderItemStepStatuses(statuses as OrderItemStepStatusKey[]);
    };

    const handleSelectOrderItemStatus = (e: React.ChangeEvent<HTMLInputElement>, status: number) => {
      const statuses = e.target.checked
        ? selectedOrderItemStepStatuses.concat([status as OrderItemStepStatusKey])
        : _.without(selectedOrderItemStepStatuses, status);
      onChangeSelectedOrderItemStepStatuses(statuses as OrderItemStepStatusKey[]);
    };

    return (
      <>
        <Button
          size="small"
          variant="outlined"
          onClick={handleClickOrderItemFilterButton}
          style={{ backgroundColor: 'white' }}
        >
          絞り込み
        </Button>
        <Popover
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleCloseOrderItemFilter}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left'
          }}
        >
          <Box display="flex">
            <FormGroup style={{ padding: '5px' }}>
              <FormLabel>ステータス</FormLabel>
              <FormControlLabel
                label="すべて選択"
                control={
                  <Checkbox
                    color="primary"
                    checked={selectedOrderItemStepStatuses.length === OrderItemStepStatusAvailable.length}
                    indeterminate={
                      selectedOrderItemStepStatuses.length !== 0 &&
                      selectedOrderItemStepStatuses.length !== OrderItemStepStatusAvailable.length
                    }
                    onChange={handleSelectAllOrderItemStepStatuses}
                  />
                }
              />
              {OrderItemStepStatusAvailable.map(key => (
                <FormControlLabel
                  key={key}
                  label={OrderItemStepStatus[key]}
                  control={
                    <Checkbox
                      color="primary"
                      checked={selectedOrderItemStepStatuses.includes(key)}
                      onChange={e => {
                        handleSelectOrderItemStatus(e, key);
                      }}
                    />
                  }
                />
              ))}
            </FormGroup>
          </Box>
        </Popover>
      </>
    );
  }
);

export default OrderItemStepStatusSelector;
